import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

// mui
import { Skeleton } from "@material-ui/lab";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Box, ClickAwayListener } from "@material-ui/core";

// style
import { ContainedButton, PrimaryActionLabel, useStyles } from "./style";
import TableCell from "./cell";

const renderLabel = (label, ellipsis, useTooltip, className) => {
    if (!get(label, "text")) return null;

    const LabelElement = (
        <TableCell
            value={
                <PrimaryActionLabel className={className || ""}>
                    {ellipsis ? <span>{label.text}</span> : label.text}
                    {label.endIcon && <ExpandMoreIcon fontSize="small" />}
                </PrimaryActionLabel>
            }
            tooltipValue={label.text}
            ellipsis={ellipsis}
            tooltip={useTooltip && label.text !== "-"}
        />
    );

    return LabelElement;
};

export default function ExpandableOptions({
    disabled,
    loading,
    label,
    expandableOptions,
    onClick,
    expandOnTop,
}) {
    const [isOpen, setIsOpen] = React.useState(false);
    const classes = useStyles({ expandOnTop });

    if (loading) return <Skeleton animation="pulse" className={classes.loader} />;

    const LabelElement = renderLabel(label, true, !isOpen);

    if (disabled) {
        return <ContainedButton>{LabelElement}</ContainedButton>;
    }

    return (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <Box
                onClick={() => setIsOpen((prev) => !prev)}
                className={`${classes.expandable} ${label.text === "-" ? classes.expandableBackground : ""}`}
            >
                {LabelElement}
                <Box className={`${classes.expandableBody} ${isOpen ? classes.active : ""}`}>
                    {isOpen
                        ? expandableOptions.map((option, index) => (
                              <div key={index} onClick={(e) => onClick(e, option, () => setIsOpen(false))}>
                                  {renderLabel(option, false, false, classes.hover)}
                              </div>
                          ))
                        : null}
                </Box>
            </Box>
        </ClickAwayListener>
    );
}

ExpandableOptions.propTypes = {
    label: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    expandableOptions: PropTypes.array,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    expandOnTop: PropTypes.bool,
};

ExpandableOptions.defaultProps = {
    loading: false,
    disabled: false,
    expandOnTop: false,
};
